import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Divider, Grid, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect, useState } from "react";
import { countryRequest } from "../../../api/CountryRequest";

interface Props {
  open: boolean;
  onClose: AnyFunction;
  onUnloadingCityCreated: AnyFunction;
  selectedUnloadingCountryId: number;
}

export default function AddUnloadingCityDialog(props: Props) {
  const { open, onClose, onUnloadingCityCreated, selectedUnloadingCountryId } =
    props;

  const [formValues, setFormValues] = useState<any>({
    name: null,
    countryId: null,
  });

  useEffect(() => {
    setFormValues((prev: any) => ({
      ...prev,
      countryId: selectedUnloadingCountryId,
    }));
  }, [selectedUnloadingCountryId]);

  const [error, setError] = useState({
    name: false,
  });

  const handleErrors = () => {
    if (!formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: true,
      }));
    } else if (formValues.name) {
      setError((prev: any) => ({
        ...prev,
        name: false,
      }));
    }
  };

  const handleSubmit = () => {
    handleErrors();
    const formIsValid = formValues.name;
    if (formIsValid) {
      return countryRequest
        .createCity(formValues)
        .then((createdUnloadingCity) => {
          if (typeof onUnloadingCityCreated === "function") {
            onUnloadingCityCreated(createdUnloadingCity);
          }
        })
        .catch(() => {
          alert("S-a produs o eroare!");
        });
    }
  };

  const handleCloseAddUnloadingCityDialog = () => {
    onClose();
    setFormValues((prev: any) => ({
      ...prev,
      name: null,
    }));
    setError(() => ({
      name: false,
    }));
  };

  return (
    <>
      <Dialog open={open} fullWidth maxWidth="xs">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <DialogTitle sx={{ pb: 0 }}>Adăugare localitate</DialogTitle>
          </Grid>
          <Grid item sx={{ mr: 2, pt: 2 }}>
            <IconButton
              onClick={handleCloseAddUnloadingCityDialog}
              tabIndex={-1}
            >
              <ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
        <DialogContent>
          <TextField
            required
            label="Nume"
            size="small"
            fullWidth
            error={error.name}
            helperText={error.name && "Câmp obligatoriu!"}
            onChange={(event) =>
              setFormValues((prev: any) => ({
                ...prev,
                name: event.target.value.toUpperCase(),
              }))
            }
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleSubmit()?.then(handleCloseAddUnloadingCityDialog);
              }
            }}
            inputProps={{ style: { textTransform: "uppercase" } }}
          ></TextField>
          <Divider sx={{ mb: 2, opacity: 0 }} />
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  handleSubmit()?.then(handleCloseAddUnloadingCityDialog);
                }}
                disabled={!formValues.name}
              >
                Salvează
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                fullWidth
                variant="outlined"
                onClick={handleCloseAddUnloadingCityDialog}
              >
                Renunță
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}
